<template>
  <div class="limiter">
      <div class="container-login">
          <div class="wrap-login">
              <div class="login-form validate-form">
                  <span class="login-form-title">
                      Sign Up !
                  </span>

                  <div class="wrap-input validate-input" data-validate="Valid email is: a@email.c">
                      <input class="input" type="email" name="email" v-model="mail">
                      <span class="focus-input" data-placeholder="Email"></span>
                  </div>

                  <div class="wrap-input validate-input" data-validate="Enter password">
                      <span class="btn-show-pass">
                          <i class="zmdi zmdi-eye"></i>
                      </span>
                      <input class="input" type="password" name="password" v-model="password">
                      <span class="focus-input" data-placeholder="Password"></span>
                  </div>

                  <div class="wrap-input validate-input" data-validate="Enter password">
                      <span class="btn-show-pass">
                          <i class="zmdi zmdi-eye"></i>
                      </span>
                      <input class="input" type="password" name="password_repeat" v-model="password_repeat">
                      <span class="focus-input" data-placeholder="Repeat password"></span>
                  </div>

                  <div class="container-login-form-btn">
                      <div class="wrap-login-form-btn">
                          <button class="login-form-btn" @click="register" value="Register"> Register </button>
                      </div>
                  </div>
                  <p v-if="msg">{{ msg }}</p>
              </div>
          </div>
      </div>
  </div>
</template>

<script type="text/javascript" src="../assets/js/login.js"></script>

<script>
import AuthService from '@/services/AuthService.js'
export default {
  name: 'Register',
  data () {
    return {
      mail: '',
      password: '',
      password_repeat: '',
      msg: ''
    }
  },
  mounted () {
    $('.input').each(function(){
        $(this).on('blur', function(){
            if($(this).val().trim() != "") {
                $(this).addClass('has-val');
            }
            else {
                $(this).removeClass('has-val');
            }
        })
    })

    var input = $('.validate-input .input');

    $('.validate-form').on('submit',function(){
        var check = true;

        for(var i=0; i<input.length; i++) {
            if(validate(input[i]) == false){
                showValidate(input[i]);
                check=false;
            }
        }

        return check;
    });

    $('.validate-form .input').each(function(){
        $(this).focus(function(){
           hideValidate(this);
        });
    });

    function validate (input) {
        if($(input).attr('type') == 'email' || $(input).attr('name') == 'email') {
            if($(input).val().trim().match(/^([a-zA-Z0.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-z9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/) == null) {
                return false;
            }
        }
        else {
            if($(input).val().trim() == ''){
                return false;
            }
        }
    }

    function showValidate(input) {
        var thisAlert = $(input).parent();

        $(thisAlert).addClass('alert-validate');
    }

    function hideValidate(input) {
        var thisAlert = $(input).parent();

        $(thisAlert).removeClass('alert-validate');
    }

    var showPass = 0;
    $('.btn-show-pass').on('click', function(){
      if(showPass == 0)
      {
          $(this).next('input').attr('type','text');
          $(this).find('i').removeClass('zmdi-eye');
          $(this).find('i').addClass('zmdi-eye-off');
          showPass = 1;
      }
      else
      {
          $(this).next('input').attr('type','password');
          $(this).find('i').addClass('zmdi-eye');
          $(this).find('i').removeClass('zmdi-eye-off');
          showPass = 0;
      }
    });
  },
  methods: {
    async register () {
      try {
        const credentials = {
          mail: this.mail,
          password: this.password,
          password_repeat: this.password_repeat
        }
        const response = await AuthService.register(credentials)
        this.msg = response.msg
      } catch (error) {
        this.msg = error.response.data.msg
      }
    }
  }
}
</script>
